<template>
    <div style="height:63rem; background-image:url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O490sz5.png');background-size:100% 100%;">
        <div style="width:100%;position:fixed;z-index:999;line-height:3rem;background-color:rgba(0, 0, 0, 0.5);">
            <van-row type="flex" justify="center">
                <van-col span="18" style="color:#eee;">关注蜂窝圈，查看领取专属福利！</van-col>
                <van-col span="5">
                    <van-button round size="small" type="primary" style="margin-bottom:0.3rem;" @click="qrVisible=true">
                        + 关注
                    </van-button>
                </van-col>
            </van-row>
        </div>
        <div style="margin-top: 18rem;">
            <table style="margin-left:15%; width: 75%;">
                <tr>
                    <td width="80%">
                        <van-field v-model="phone" type="number" style="height: 3.3rem;"></van-field>
                    </td>
                    <td width="20%">
                        <van-button class="phoneButton" @click="sendPhoneCode"></van-button>
                    </td>
                </tr>
                <tr>
                    <van-field v-model="code" type="number" placeholder="请输入验证码"
                               style="height: 3.3rem; width: 70%;"></van-field>
                </tr>
                <tr>
                    <van-button class="confirmButton" @click="phoneCodeValidate"></van-button>
                </tr>
            </table>
        </div>

        <van-dialog v-model="qrVisible" confirm-button-text="长按识别二维码关注" close-on-click-overlay>
            <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O3B53K5.jpg" width="100%"/>
        </van-dialog>

        <van-dialog v-model="dialogVisible" confirm-button-text="关闭">
            <div style="min-height: 35rem; background-image:url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O41JGsy.jpg');background-size:100% 100%;">
                <img :src="couponImg" style="width: 7rem; padding: 28rem 15rem 0 3rem;"/>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import happyPotatoAPI from '@/api/happyPotato';

    export default {
        data() {
            return {
                phone: '',
                code: '',
                qrVisible: false,
                dialogVisible: false,
                couponImg: '',
            }
        },
        methods: {
            sendPhoneCode() {
                if (!this.$myUtil.mobile(this.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                this.$toast.loading({forbidClick: true});
                happyPotatoAPI.sendPhoneCode(this.phone).then((result) => {
                    this.$toast("发送成功");
                }).catch(() => {
                });
            },
            phoneCodeValidate() {
                if (!this.phone) {
                    this.$toast("手机号为空");
                    return;
                }
                this.$toast.loading({forbidClick: true});
                happyPotatoAPI.phoneCodeValidate(this.phone, this.code).then((result) => {
                    // 领取成功，弹窗
                    this.dialogVisible = true;
                    this.couponImg = result.data;
                    this.$toast.clear();
                }).catch(() => {
                });
            },
        },
        created() {
            document.title = "快乐番薯";
        }
    }

</script>

<style lang="scss" scoped>

    .phoneButton {
        margin-left: 2%;
        width: 100%;
        height: 3.5rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O48eocL.png");
        background-size: 100% 100%;
        border-style: none;
        border-radius: 1rem;
    }

    .confirmButton {
        margin-left: 5%;
        margin-top: 0.5rem;
        width: 60%;
        height: 3.5rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O48en1t.png");
        background-size: 100% 100%;
        border-style: none;
        border-radius: 1rem;
    }

</style>
